@if (items && items.length) {
  <div class="carousel-wrapper">
    <h4 class="mb-3" translate>{{related?.name}}
      @if (related?.subTitle) {
        <p translate>{{related.subTitle}}</p>
      }
    </h4>
    <!-- documentation: https://github.com/sheikalthaf/ngu-carousel -->
    @if (layout == CarouselLayout.CAROUSEL) {
      <ngu-carousel #myCarousel
        [inputs]="carouselBanner"
        [dataSource]="items"
        (carouselLoad)="carouselTileLoad($event)" >
        <ngu-tile *nguCarouselDef="let item; " class="nguTileStyle">
          @for (i of item; track i) {
            <div class="row-carousel h-100">
              <product-card [ngClass]="previewTemplateVar ? 'entity-product-card' : 'card card-item'" class="text-lg-center" [item]="i" [previewTemplateVar]="previewTemplateVar"></product-card>
            </div>
          }
        </ngu-tile>
        <button NguCarouselPrev class='leftRs' dir="ltr" [style.opacity]="myCarousel.isFirst ? 0:1">
          <i class="material-icons color-grey-700">arrow_back_ios</i>
        </button>
        <button NguCarouselNext class='rightRs' dir="ltr" [style.opacity]="myCarousel.isLast ? 0:1">
          <i class="material-icons color-grey-700">arrow_forward_ios</i>
        </button>
        @if (carouselIndicators) {
          <ul class="carouselIndicators" NguCarouselPoint>
            @for (point of myCarousel.pointNumbers(); track point; let i = $index) {
              <li [class.active]="point==myCarousel.activePoint()" (click)="myCarousel.moveTo(i)"></li>
            }
          </ul>
        }
      </ngu-carousel>
    }
    @if (layout == CarouselLayout.FLAT) {
      <div class="card-wrapper">
        @for (item of items; track item) {
          <div >
            @for (i of item; track i) {
              <product-card  [ngClass]="previewTemplateVar ? 'entity-product-card' : 'card card-item'" class="text-lg-center" [item]="i" [previewTemplateVar]="previewTemplateVar"></product-card>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  @if (loading) {
    <contentloader></contentloader>
  }
}

<!-- contentloader -->
